import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "refresh",
  "use": "refresh-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"refresh\"><defs><style></style></defs><path d=\"M128 800v160a32 32 0 11-64 0V704a32 32 0 0135.968-31.744l256 32a32 32 0 11-7.936 63.488l-180.608-22.592A416 416 0 00928 512h64a480 480 0 01-864 288zm771.968-570.688V64.192a32 32 0 1164 0v256A32 32 0 01928 352l-256-32a32 32 0 017.936-63.488l176.448 22.016A416 416 0 0096 512H31.936a480 480 0 01867.968-282.688z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol